<template>
  <div class="scroll_flex_container">
    <memberBanner />

    <userInfoForm ref="userInfoForm" />
  </div>
</template>
<script>
import memberBanner from "../components/memberBanner.vue";
import userInfoForm from "../components/memberInfo/userInfoForm.vue";
export default {
  components: {
    memberBanner: memberBanner,
    UserInfoForm: userInfoForm,
  },
  data() {
    return {};
  },
  computed: {
    getCurrentStore() {
      return this.$store.getters['userData/storeCode']
    },
  },
  methods: {

  },
  beforeRouteLeave(to, from) {
    console.log("change member info page leave", to, from);
    const userInfoForm = this.$refs.userInfoForm;

    if (userInfoForm.isFormDataUpdated() || userInfoForm.isAddressUpdate()) {
      const answer = window.confirm("您有尚未儲存的變更，要捨棄變更嗎？");
      if (!answer) return false;
    }
  },
};
</script>
<style lang="scss"></style>
